/**
 * Material Constants - Single Source of Truth
 *
 * Bu dosya shared/constants/ altında tutulur ve sync-shared.js ile
 * hem backend (materials.js) hem frontend (materials.ts) dizinlerine kopyalanır.
 *
 * USAGE (Backend):
 * const { MALZEME_KATEGORI, MALZEME_KATEGORI_VALUES } = require('../shared/constants/materials');
 *
 * USAGE (Frontend):
 * import { MALZEME_KATEGORI_LABELS } from '../shared/constants/materials';
 *
 * NOT: DB'de enum değerleri Türkçe karaktersiz büyük harf tutulur (PROFIL, SUNGER...).
 * Ekranda MALZEME_KATEGORI_LABELS ile düzgün Türkçe gösterilir (PROFİL, SÜNGER...).
 */

// SAAS-COUPLING: kategoriler TrioCare'in imalat girdileri (profil, sünger, yatak altı, burç,
// lazer kesim...) ve DB'deki malzeme_kategori_enum aynı küme — hardcoded — çıkarmada
// kiracının tanımladığı kategori tablosu olur (ENUM yerine tablo, migration ister).
// Birimler genel, etiket dışı.
export const MALZEME_KATEGORI = {
    PROFIL: 'PROFIL',
    MOBILYA: 'MOBILYA',
    MOTOR: 'MOTOR',
    BASLIK: 'BASLIK',
    SARF: 'SARF',
    SUNGER: 'SUNGER',
    DERI: 'DERI',
    YATAK_ALT: 'YATAK_ALT',
    BURC: 'BURC',
    LAMA: 'LAMA',
    TRANSMISYON: 'TRANSMISYON',
    LAZER_KESIM: 'LAZER_KESIM',
    DIGER: 'DIGER'
} as const;

export type MalzemeKategori = typeof MALZEME_KATEGORI[keyof typeof MALZEME_KATEGORI];

// Ekranda gösterilecek düzgün Türkçe etiketler (dropdown, tablo, filtre)
export const MALZEME_KATEGORI_LABELS: Record<string, string> = {
    PROFIL: 'PROFİL',
    MOBILYA: 'MOBİLYA',
    MOTOR: 'MOTOR',
    BASLIK: 'BAŞLIK',
    SARF: 'SARF',
    SUNGER: 'SÜNGER',
    DERI: 'DERİ',
    YATAK_ALT: 'YATAK ALT',
    BURC: 'BURÇ',
    LAMA: 'LAMA',
    TRANSMISYON: 'TRANSMİSYON',
    LAZER_KESIM: 'LAZER KESİM',
    DIGER: 'DİĞER'
};

// Enum sırasıyla değer listesi (Joi validation + dropdown)
export const MALZEME_KATEGORI_VALUES: string[] = Object.keys(MALZEME_KATEGORI_LABELS);

// ─── Malzeme Birimleri ───────────────────────────────────────────────
// DB'de büyük harf enum tutulur (ADET, M2...); ekranda LABELS ile gösterilir (Adet, m²...).
export const MALZEME_BIRIM = {
    ADET: 'ADET',
    BOY: 'BOY',
    METRE: 'METRE',
    M2: 'M2',
    SET: 'SET',
    TAKIM: 'TAKIM',
    M3: 'M3',
    LITRE: 'LITRE'
} as const;

export type MalzemeBirim = typeof MALZEME_BIRIM[keyof typeof MALZEME_BIRIM];

export const MALZEME_BIRIM_LABELS: Record<string, string> = {
    ADET: 'Adet',
    BOY: 'Boy',
    METRE: 'Metre',
    M2: 'm²',
    SET: 'Set',
    TAKIM: 'Takım',
    M3: 'm³',
    LITRE: 'Litre'
};

export const MALZEME_BIRIM_VALUES: string[] = Object.keys(MALZEME_BIRIM_LABELS);

// ─── Malzeme fiyat geçmişinin kaynağı (malzeme_fiyat_gecmisi.kaynak) ───
// DB ENUM'u değil, CHECK kısıtı. Değeri tetikleyici yazar: uygulama işlemin başında
// `crm.fiyat_kaynagi` oturum ayarını EKRAN yapar, ayar boşsa VERITABANI (pgAdmin, betik).
// BASLANGIC yalnız ilk kurulumun satırlarıdır. Değerler kayıtlarda durduğu için
// değiştirilmez, yalnız eklenir; eklenen değer CHECK kısıtına da yazılır.
export const MALZEME_FIYAT_KAYNAGI = {
    EKRAN: 'EKRAN',
    VERITABANI: 'VERITABANI',
    BASLANGIC: 'BASLANGIC'
} as const;

export const ALL_MALZEME_FIYAT_KAYNAGI = Object.values(MALZEME_FIYAT_KAYNAGI);

export type MalzemeFiyatKaynagi = typeof ALL_MALZEME_FIYAT_KAYNAGI[number];
